import React from "react";

import { Badge, Text, Link, ResourceItem, InlineStack } from "@shopify/polaris";
import { CreditCardIcon, ExitIcon, TransactionIcon } from "@shopify/polaris-icons";

import PropTypes from "prop-types";

// import from lib
import Popover from "lib/components/popover/popover";
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

const SellerListView = (props) => {
  const {
    activePopover,
    item,
    keyIndex,
    onLoginSeller,
    onUpdateSeller,
    popoverDisable,
    sellerListCMS,
    setActivePopover,
    handleDisableApiModal,
    enableDisableApiLoading,
    isApiAccessLoading,
  } = props;
  const { _id, brandName, email, plan, roles, api = {} } = item;
  const { status = "" } = api || {};
  const { address, verified } = email;
  const { code: planCode = "", name: planName = "" } = plan || {};
  const { name: role } = roles;
  const { button, label } = sellerListCMS;
  const apiStatus = [constant.PENDING_SMALL, constant.DISABLED];

  const topMargin10px = {
    marginTop: "10px",
  };

  const handleSelectAction = (selectAction, id, operatorBrandName, operatorRole) => {
    if (selectAction === "login") {
      onLoginSeller(id, operatorBrandName, operatorRole);
    } else {
      onUpdateSeller(id, operatorBrandName, operatorRole);
    }
  };

  const optionList = [
    {
      content: button.updatePlan,
      icon: CreditCardIcon,
      onAction: () => handleSelectAction("updatePlan", _id, brandName, role),
    },
    {
      content: button.loginSeller,
      icon: ExitIcon,
      onAction: () => handleSelectAction("login", _id, brandName, role),
    },
  ];

  if (status) {
    optionList.push({
      content: apiStatus.includes(status) ? "Enable API" : "Disable API",
      icon: TransactionIcon,
      onAction: () => handleDisableApiModal(),
      loading: enableDisableApiLoading,
      destructive: !apiStatus.includes(status) || false,
    });
  }

  return (
    <>
      <ResourceItem id={_id} sortOrder={keyIndex} accessibilityLabel={`${label.viewDetailsFor} ${brandName}`}>
        <InlineStack>
          <Link url={`/operators/view/${_id}`}>
            <Text as="span">{baseHelper.ucFirst(brandName)}</Text>
          </Link>
          <Text variant="bodySm" as="p">
            <Text as="span">{`${label.email}: ${address}`}</Text>
            <Text as="span">{`${label.plan}: ${planCode || planName || ""}`}</Text>
            <Text as="span">{`API Status: ${baseHelper.ucFirst(status) || constant.NOT_REQUESTED}`}</Text>
          </Text>
          <div style={topMargin10px}>
            <InlineStack>
              <Badge status={verified ? constant.SUCCESS : constant.NEW}>
                {verified ? constant.APPROVED : constant.PENDING}
              </Badge>
            </InlineStack>
          </div>
          <Popover
            // eslint-disable-next-line no-underscore-dangle
            active={activePopover[_id]}
            // eslint-disable-next-line no-underscore-dangle
            setActive={() =>
              popoverDisable ? setActivePopover(false) : setActivePopover({ [_id]: !activePopover[_id] })
            }
            options={optionList}
            loading={isApiAccessLoading[_id]}
          />
        </InlineStack>
      </ResourceItem>
    </>
  );
};

SellerListView.defaultProps = {
  item: {},
  keyIndex: "",
  onUpdateSeller: () => {},
  onLoginSeller: () => {},
  activePopover: {},
};

SellerListView.propTypes = {
  item: PropTypes.objectOf(PropTypes.shape),
  keyIndex: PropTypes.number,
  onUpdateSeller: PropTypes.func,
  onLoginSeller: PropTypes.func,
  activePopover: PropTypes.objectOf(),
  setActivePopover: PropTypes.func.isRequired,
  sellerListCMS: PropTypes.func.isRequired,
};

export default SellerListView;
